import _get from 'lodash/get';
import { trackLink } from '../../lib/analytics-helper';
import * as types from '../constants/ActionTypes';
import { fetchTopicData } from './action-topic-data';
import { fetchRelatedArticle } from './action-related-article';
import { postChatBotEligibility, postChatBotEligibleFalse } from './action-postchatbot-eligibility';
import Page from '../../lib/page';
import { fetchPhoneNumber } from './action-call-us';
import { validateAMFlag } from '../../lib/globalHelper';

function selectTopicUpdateL1({ subTopic }) {
  return {
    type: types.SELECT_TOPIC_L1,
    payload: subTopic,
  };
}

function selectTopicUpdateL2(data) {
  return {
    type: types.SELECT_TOPIC_L2,
    payload: data,
  };
}

function selectTopicUpdateL3({ topicId, topicName }) {
  return {
    type: types.SELECT_TOPIC_L3,
    payload: {
      topicId,
      topicName,
    },
  };
}

export function selectTopicResult({
  topicId, topicName, topicRefId, parentTopicName, breadCrumbItems,
}) {
  Page.removeSession('showContactOptions');
  return {
    type: types.SELECT_RESULT,
    payload: {
      topicId,
      topicName,
      topicRefId,
      parentTopicName,
      breadCrumbItems,
    },
  };
}

export function selectTopicL1({ subTopic, topicRefId }) {
  return (dispatch, getState) => {
    const preTopicRef = _get(getState(), 'topicTree.topicTreeSelectionL1.ref_id');
    const newTopicRef = _get(subTopic, 'ref_id');
    if (preTopicRef && newTopicRef && preTopicRef !== newTopicRef) {
      trackLink({ id: 'contactUsPage', link: `smarthelp-switch-topic-L1|${newTopicRef}|${preTopicRef}|` });
    }
    trackLink({ id: 'contactUsPage', link: `smarthelp-select-topic-L1|${topicRefId}|` });
    dispatch(selectTopicUpdateL1({ subTopic }));
    dispatch(postChatBotEligibleFalse());
  };
}

// TODO: fetch article data for layer two
export function selectTopicL2({ topicId, subTopic, content }) {
  return (dispatch, getStore) => {
    const prevL2 = _get(getStore(), 'topicTree.topicTreeSelectionL2.ref_id');
    let newL2;
    if (subTopic && !content) {
      newL2 = subTopic.ref_id;
      trackLink({ id: 'contactUsPage', link: `smarthelp-select-topic-L2|${subTopic.ref_id}|` });
      dispatch(selectTopicUpdateL2(subTopic));
    } else {
      newL2 = content.ref_id;
      // The final FPTI intent has been moved to `action-final-contact-options.js` since we needed to wait for the contact options to resolve.
      dispatch(selectTopicUpdateL2(content));
      // dispatch article search action using topic ID
      dispatch(selectTopicResult({
        topicId: content.topic_id,
        topicName: content.topic_name,
        topicRefId: content.ref_id,
      }));

      // Fire post chat bot eligibility API after selecting final intent.
      const postChatBotResponse = Page.getChatBotEligibilityParams(content.ref_id, 'TOPIC');
      dispatch(postChatBotEligibility(postChatBotResponse));

      dispatch(fetchTopicData(topicId));
      dispatch(fetchRelatedArticle(content.topic_name));

      // if L2 topic us final intent trigger callus API to display callus option if AM flag exists the response
      if (validateAMFlag()) {
        dispatch(fetchPhoneNumber());
      }
    }
    if (prevL2 && newL2 && prevL2 !== newL2) {
      trackLink({ id: 'contactUsPage', link: `smarthelp-switch-topic-L2|${newL2}|${prevL2}` });
    }
  };
}

// TODO: fetch article data for layer three
export function selectTopicL3({ topicId, topicName, topicRefId }) {
  return (dispatch) => {
    // The final FPTI intent has been moved to `action-final-contact-options.js` since we needed to wait for the contact options to resolve.
    dispatch(selectTopicUpdateL3({ topicId, topicName }));
    // dispatch article search action using topic ID
    dispatch(selectTopicResult({ topicId, topicName, topicRefId }));
    dispatch(fetchTopicData(topicId));
    dispatch(fetchRelatedArticle(topicName));

    // Fire post chat bot eligibility API after selecting final intent.
    const postChatBotResponse = Page.getChatBotEligibilityParams(topicRefId, 'TOPIC');
    dispatch(postChatBotEligibility(postChatBotResponse));

    // if L3 topic us final intent trigger callus API to display callus option if AM flag exists the response
    if (validateAMFlag()) {
      dispatch(fetchPhoneNumber());
    }
  };
}

export function selectTopicReset(options) {
  return {
    type: types.SELECT_TOPIC_RESET,
    payload: options,
  };
}

export function selectTopic(options) {
  return {
    type: types.SELECT_TOPIC,
    payload: options,
  };
}

function selectIntentSearchTopic() {
  return { type: types.CRAWLING_SEARCH_TOPIC };
}

export function fetchFinalTopicContent(options = {}) {
  return (dispatch) => {
    const topic = options.topic;
    dispatch(selectIntentSearchTopic());
    dispatch(selectTopicResult(topic));
    dispatch(fetchTopicData(topic.topicId));
    return dispatch(fetchRelatedArticle(topic.topicName));
  };
}

// Users selecting the topic selection in the search results
export function crawlingSearchTopic(options) {
  return (dispatch) => {
    if (!options || !options.topic_id) {
      return null;
    }

    const topic = {
      topicId: options.topic_id,
      topicName: options.topic_name,
      topicRefId: options.ref_id,
      breadCrumbItems: options.parents || [],
      // If a user clicks a search suggestion, they go straight to the topic, so we must get the Layer 2 topic name
      parentTopicName: options.parents[1] || '',
    };

    dispatch(fetchFinalTopicContent({ topic }));

    // dispatch postchatbot eligibility response
    const postChatBotResponse = Page.getChatBotEligibilityParams(topic.topicRefId, 'TOPIC');
    dispatch(postChatBotEligibility(postChatBotResponse));
    return null;
  };
}
